const TOOL_DISPLAY_NAME_OVERRIDES: Readonly<Record<string, string>> = {
  human_handover: "Escalate to Human",
  send_email: "Send Email",
}

/** Keeps legacy/internal tool names out of user-facing surfaces. */
export function getAiToolDisplayName(
  toolName: string,
  storedDisplayName?: string | null,
): string {
  return TOOL_DISPLAY_NAME_OVERRIDES[toolName]
    ?? storedDisplayName
    ?? toolName.replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase())
}
